/**
 * Environment detection for the frontend
 * Works reliably across different deployment platforms (Vercel, Netlify, Railway, etc.)
 */

// Check multiple sources for environment detection
const getEnvironment = (): 'production' | 'development' | 'dev2' => {
  // Method 1: Check hostname FIRST (most reliable for runtime detection)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'genanything.ai' || hostname === 'www.genanything.ai') {
      return 'production';
    }
    if (hostname === 'dev.genanything.ai') {
      return 'development';
    }
    if (hostname === 'dev2.genanything.ai') {
      return 'dev2';
    }
  }
  
  // Method 2: Check custom env var (runtime variable)
  if (process.env.REACT_APP_ENV === 'production' ||
      process.env.NEXT_PUBLIC_ENV === 'production' ||
      process.env.VITE_ENV === 'production') {
    return 'production';
  }
  
  // Method 3: Check NODE_ENV (build-time variable) - LAST because it's often 'production' for all builds
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  
  // Default to development if unclear
  return 'development';
};

export const ENV = getEnvironment();
export const IS_PRODUCTION = ENV === 'production';
export const IS_DEVELOPMENT = ENV === 'development';

// API URL based on environment
export const API_URL = IS_PRODUCTION 
  ? 'https://api.genanything.ai'
  : 'https://devapi.genanything.ai';

console.log(`[Environment] Running in ${ENV} mode, API: ${API_URL}`);
